// Component for protected routes in admin mode
// If there is no token, redirect to the database page

import React from "react";
import { Navigate } from "react-router-dom";
import Cookies from "universal-cookie";

const cookies = new Cookies();

export default function ProtectedRoute({ element }) {

    const token = cookies.get("TOKEN");

    if (!token) {
        console.log("Invalid token");
        return <Navigate to="/login" />;
    }
    
    return element;
}
